// extracted by mini-css-extract-plugin
export default {"layout":"layout--to2F7w1AO6CxcWsjkfEw"};